module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh":{"quick_command":"快捷指令","input_keyword":"请输入关键字","group":"分组","all":"全部","command_exists":"指令已存在","command_added":"指令已添加，可继续添加或关闭"},"en":{"quick_command":"Instruction","input_keyword":"Please enter a keyword","group":"Group","all":"All","command_exists":"Command already exists","command_added":"Command added, you can continue to add or close"}}')
  delete Component.options._Ctor
}
